import { createContext } from 'react';

export default createContext({ setValues: () => {}, getValues: () => ({}), validate: () => {} });
